<template>
    <div class="viewsee" >
        <div class="viewText">
            属性信息
            <span @click="$emit('close')">x</span>
        </div>
        <div class="con">
            <div class="item" v-for="(val, key) in title" :key="key" >
                <div >{{key}}</div>
                <div >{{val}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['textname'],
    data(){
        return {
        }
    },
    computed:{
        title(){
            let arr = this.textname.split('_').filter(item => item.trim())
            console.log(arr);
            let obj = {
                "名称 :":arr[0],
                "类型 :":arr[1],
                "尺寸 :":arr[2],
                "ID :":arr[arr.length - 1]
            }
            return obj
        }
    }
}
</script>

<style lang="less" scoped>
    

    .viewsee{
        position: fixed;
        right: 1vw;
        top: 17vh;
        width: 30vw;
        // min-height: 15vh;
        background-color: #3f3e3cCC ;
        // opacity: 0.8;
        .viewText{
            height:4vh ;
            line-height: 4vh;
            padding:0 1vw ;
            font-size: 14px;
            color: #fff ;
            border-bottom: 1px solid #f0f0f0;
            position: relative;
            &>span{
                position: absolute;
                right: 1vw;
                top: 0vh;
                transform: scale(1.5);
                cursor: pointer;
            }
        }
        .con{
            background-color: rgba(45, 33, 33, 0.75);
            min-height: 10vh;
            color: #fff;
            .item{
                height: 5vh;
                font-size: 12px;
                padding: 0 1vw;
                box-sizing: border-box;
                border-top: 1px dashed rgba(221, 221, 221, 0.45);
                display: flex;
                justify-content: space-between;
                align-items: center;
                .text{
                    &>img{
                        width: 4vw;
                        height: 2vh;
                        vertical-align: middle;
                        margin-right: 0.5vw;
                    }
                }
            }
            .item:nth-child(1){
                border-top:1px solid rgba(221, 221, 221, 0.45) ;
            }
        }
    }
</style>